import * as React from 'react';

const SvgCup = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
  >
    <path
      d='M44.4699 38.2284H11.5357C8.84177 38.2284 6.55815 36.268 6.21917 33.6656L3.54305 12.8467C3.3468 11.372 3.8285 9.87996 4.84543 8.75226C5.86236 7.64192 7.3253 7 8.85962 7H47.146C48.6803 7 50.1433 7.64192 51.1602 8.75226C52.1771 9.87996 52.641 11.3546 52.4626 12.8467L49.7865 33.6656C49.4475 36.268 47.1639 38.2284 44.4699 38.2284Z'
      fill='#FF0037'
    />
    <path
      d='M45.4155 47.25C34.1044 44.4915 21.9191 44.4915 10.608 47.25L9.73382 43.8843C21.6158 40.987 34.4077 40.987 46.2897 43.8843L45.4155 47.25Z'
      fill='#FF0037'
    />
  </svg>
);

export default SvgCup;
